import React from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { colors, theme } from "../../theme/theme";
import { Box, Typography } from "@mui/material";

const CustomDatePicker = ({
  value,
  setValue,
  width = "100%",
  minDate,
  noBorder = false,
  label,
  color,
  mT,
  iconColor,
  borderColor,
}) => {
  return (
    <Box sx={{ width: width, mt: mT || 0 }}>
      {label && (
        <Typography
          sx={{
            fontFamily: "Mulish-Regular",
            fontSize: "12px",
            color: colors.textColor,
            fontWeight: "700",
            mb: 0.5,
            textTransform: "uppercase",
            textAlign: "left",
          }}
        >
          {label}
        </Typography>
      )}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={value}
          onChange={(e) => setValue(e)}
          minDate={minDate || dayjs()}
          format="DD/MM/YYYY"
          sx={{
            width: width,
            ".MuiPickersOutlinedInput-notchedOutline": {
              border: "none",
            },
            borderRadius: "10px",
            ".MuiSvgIcon-root": {
              fill: iconColor || `rgba(255,255,255,0.5) !important`,
            },
            ".MuiPickersSectionList-root": {
              color: color || "#fff",
              "&::placeholder": {
                color: "rgba(255,255,255,0.5)",
                opacity: 1,
              },
            },
          }}
          slotProps={{
            textField: {
              focused: false,
              InputLabelProps: {
                style: { color: "gray" },
              },
              InputProps: {
                style: {
                  color: color || "#fff",
                },
                sx: {
                  height: "55px",
                  backgroundColor: "transparent",
                  borderRadius: "9px",
                  width: width,
                  border: theme.lightBorder,
                  borderColor: borderColor || theme.lightBorder,
                  "&:hover": {
                    border: theme.lightBorder,
                  },
                },
              },
            },
          }}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default CustomDatePicker;
